var React = require('react');

function IconEmailGray (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"25","cy":"25","r":"24","stroke":"#555658","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M13.8 14H36.2C37.74 14 39 15.2375 39 16.75V33.25C39 34.7625 37.74 36 36.2 36H13.8C12.26 36 11 34.7625 11 33.25V16.75C11 15.2375 12.26 14 13.8 14Z","stroke":"#555658","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M39 17L25 27L11 17","stroke":"#555658","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

IconEmailGray.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50","fill":"none"};

module.exports = IconEmailGray;

IconEmailGray.default = IconEmailGray;
